import * as yup from 'yup';

export const schemaInventoryOutput = yup.object().shape({
  product_id: yup.string().required('Produto é obrigatório'),
  quantity: yup
    .number()
    .min(1, 'Quantidade mínima deve ser maior que zero')
    .required('Quantidade é obrigatória'),
});
